var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTournament(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 54,
    viewBox: "0 0 47 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4,
    cx: 27,
    cy: 34,
    r: 20,
    fill: "#47D3FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2002_59)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.17157 1.0837C9.92172 0.38982 10.9391 0 12 0H28C29.0609 0 30.0783 0.389821 30.8284 1.0837C31.5786 1.77759 32 2.7187 32 3.7V4.93333H33.3333C35.1014 4.93333 36.7971 5.58303 38.0474 6.73951C39.2976 7.89598 40 9.4645 40 11.1C40 12.7355 39.2976 14.304 38.0474 15.4605C36.7971 16.617 35.1014 17.2667 33.3333 17.2667H31.3137C30.7227 18.8129 29.7629 20.2338 28.4853 21.4156C26.5514 23.2044 24.0254 24.3196 21.3333 24.598V34.5333H29.3333V37H10.6667V34.5333H18.6667V24.598C15.9746 24.3196 13.4486 23.2044 11.5147 21.4156C10.2371 20.2338 9.27732 18.8129 8.68629 17.2667H6.66667C4.89856 17.2667 3.20286 16.617 1.95262 15.4605C0.702379 14.304 0 12.7355 0 11.1C0 9.4645 0.702379 7.89598 1.95262 6.73951C3.20286 5.58303 4.89856 4.93333 6.66667 4.93333H8V3.7C8 2.7187 8.42143 1.77759 9.17157 1.0837ZM8 7.4H6.66667C5.6058 7.4 4.58839 7.78982 3.83824 8.48371C3.08809 9.17759 2.66667 10.1187 2.66667 11.1C2.66667 12.0813 3.08809 13.0224 3.83824 13.7163C4.58839 14.4102 5.6058 14.8 6.66667 14.8H8.07426C8.02501 14.3924 8 13.9807 8 13.5667V7.4ZM31.9257 14.8H33.3333C34.3942 14.8 35.4116 14.4102 36.1618 13.7163C36.9119 13.0224 37.3333 12.0813 37.3333 11.1C37.3333 10.1187 36.9119 9.17759 36.1618 8.48371C35.4116 7.78982 34.3942 7.4 33.3333 7.4H32V13.5667C32 13.9807 31.975 14.3924 31.9257 14.8ZM12 2.46667C11.6464 2.46667 11.3072 2.59661 11.0572 2.8279C10.8071 3.0592 10.6667 3.3729 10.6667 3.7V13.5667C10.6667 15.8564 11.65 18.0523 13.4003 19.6714C15.1507 21.2904 17.5246 22.2 20 22.2C22.4754 22.2 24.8493 21.2904 26.5997 19.6714C28.35 18.0523 29.3333 15.8564 29.3333 13.5667V3.7C29.3333 3.3729 29.1929 3.0592 28.9428 2.8279C28.6928 2.59661 28.3536 2.46667 28 2.46667H12Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2002_59"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 37,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTournament);
export default __webpack_public_path__ + "static/media/icon-tournament.4d2f3f7662488818543618fdaf5b4fb0.svg";
export { ForwardRef as ReactComponent };